export default {
  title: 'Déclarez vos biens',
  emptyProperties: 'Pas de biens encore déclarés',
  addProperty: 'Ajouter un bien',
  beforeLeave: {
    title: 'Attention : Avant de quitter la page',
    text: 'Vous n\'avez pas sauvegardé votre déclaration, voulez-vous néanmoins quitter la page ? (Votre déclaration de valeur ne sera pas sauvegardée)',
  },
  modal: {
    titleEdit: 'Éditer un bien',
    titleAdd: 'Ajouter un bien',
    date: {
      name: 'Date d\'achat',
      warning: 'S\'il vous plait sélectionnez une date',
    },
    name: {
      name: 'Nom du bien',
      warning: 'S\'il vous plait rentrez un nom',
    },
    quantity: {
      name: 'Nombre de biens',
      warning: 'S\'il vous plait rentrez un nombre de biens valide',
    },
    price: {
      name: 'Prix du bien',
      warning: 'S\'il vous plait rentrez un prix valide',
    },
  },
  tab: {
    date: 'Date',
    name: 'Nom',
    quantity: 'Nombre de biens',
    price: 'Prix',
    operations: 'Operations',
  },
};
